
  import { Vue, Component, Watch, Prop } from "vue-property-decorator";

  import FiltersContainer from "@/components/filters/filters-container.vue";
  import UIButton from "@/components/button/ui-button.vue";
  import FormGroup from "@/components/form/FormGroup.vue";
  import CompaniesMultiselect from "@/components/autocompleteMultiselects/CompaniesMultiselect.vue";
  import InputRangeFilter from "@/components/filters/InputRangeFilter.vue";
  import EmploymentMultiselect from "@/components/autocompleteMultiselects/EmploymentMultiselect.vue";
  import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselect.vue";
  import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelect.vue";
  import PostingCityMultiselect from "@/components/autocompleteMultiselects/PostingCityMultiselect.vue";

  import DropdownOption from "@/entities/DropdownOption";
  import ApplicationFilters from "@/entities/filters/ApplicationFilters";

  import getMultiselectValues from "@/helpers/multiselect/getMultiselectValues";
  import RegionInput from "@/components/autocompleteMultiselects/RegionInput.vue";

  @Component({
    components: {
      RegionInput,
      FiltersContainer,
      UIButton,
      FormGroup,
      CompaniesMultiselect,
      EmploymentMultiselect,
      InputRangeFilter,
      SkillsMultiselect,
      ProfileCountrySelect,
      PostingCityMultiselect,
    },
  })
  export default class JobBoardApplicationsFilters extends Vue {
    @Prop({ type: String, default: true }) currentUserId!: string;
    @Prop({ type: Object, required: true }) readonly filters!: ApplicationFilters;

    countries: DropdownOption[] = [];
    states: DropdownOption[] = [];
    cities: DropdownOption[] = [];
    companiesIds: string[] = [];
    employmentTypes: DropdownOption[] = [];
    skillsIds: number[] = [];

    get countryName(): string {
      return this.countries[0]?.name || "";
    }

    get companiesCondition(): Object {
      return {
        postings: {
          applications: {
            user_id: { _eq: this.currentUserId },
          },
        },
      };
    }

    get postingsCondition(): Object {
      return {
        applications: {
          user_id: { _eq: this.currentUserId },
        },
      };
    }

    get filtersToWatch(): string {
      return JSON.stringify([
        this.countries,
        this.states,
        this.cities,
        this.companiesIds,
        this.employmentTypes,
        this.skillsIds,
      ]);
    }

    get countriesNames(): string[] {
      return this.countries.map((country) => country.name);
    }

    get statesNames(): string[] {
      return this.states.map((state) => state.name);
    }

    get citiesNames(): string[] {
      return this.cities.map(city => city.name);
    }

    get employmentType(): string[] {
      return this.employmentTypes.map((type) => type.name);
    }

    @Watch("filtersToWatch")
    handlePropToWatchChange(): void {
      this.$emit("filtersChanged", {
        countries: this.countriesNames,
        states: this.statesNames,
        cities: this.citiesNames,
        companies: this.companiesIds,
        employmentTypes: this.employmentType,
        skills: this.skillsIds,
      });
    }

    @Watch("filters", { immediate: true })
    updateFiltersValues(): void {
      this.countries = getMultiselectValues(this.filters.countries);
      this.states = getMultiselectValues(this.filters.states);
      this.cities = getMultiselectValues(this.filters.cities);
      this.companiesIds = this.filters.companies;
      this.skillsIds = this.filters.skills;
      this.employmentTypes = getMultiselectValues(this.filters.employmentTypes);
    }

    handleReset() {
      this.$emit("resetFilters");
    }
  }
